import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUsers, FiDollarSign, FiTrendingUp, FiTarget, FiClock, FiCheckCircle } = FiIcons;

const AdminStatsCards = ({ clients, users }) => {
  const totalValue = clients.reduce((sum, client) => sum + client.contractValue, 0);
  const totalCommissions = clients.reduce((sum, client) => sum + (client.commission || 0), 0);
  const paidClients = clients.filter(c => c.status === 'pagato' || c.status === 'commissionato').length;
  const pendingClients = clients.filter(c => c.status === 'nuovo_lead' || c.status === 'in_trattativa').length;

  const stats = [
    {
      title: 'Venditori Attivi',
      value: users.length,
      icon: FiUsers,
      color: 'blue',
      change: null
    },
    {
      title: 'Valore Totale',
      value: `€${totalValue.toLocaleString()}`,
      icon: FiDollarSign,
      color: 'green',
      change: null
    },
    {
      title: 'Commissioni Pagate',
      value: `€${totalCommissions.toLocaleString()}`,
      icon: FiTrendingUp,
      color: 'emerald',
      change: null
    },
    {
      title: 'Clienti Pagati',
      value: paidClients,
      icon: FiCheckCircle,
      color: 'purple',
      change: null
    },
    {
      title: 'In Attesa',
      value: pendingClients,
      icon: FiClock,
      color: 'orange',
      change: null
    },
    {
      title: 'Tasso Conversione',
      value: `${clients.length > 0 ? Math.round((paidClients / clients.length) * 100) : 0}%`,
      icon: FiTarget,
      color: 'indigo',
      change: null
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-500 text-blue-600 bg-blue-50',
    green: 'bg-green-500 text-green-600 bg-green-50',
    emerald: 'bg-emerald-500 text-emerald-600 bg-emerald-50',
    purple: 'bg-purple-500 text-purple-600 bg-purple-50',
    orange: 'bg-orange-500 text-orange-600 bg-orange-50',
    indigo: 'bg-indigo-500 text-indigo-600 bg-indigo-50'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 mb-8">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorClasses[stat.color].split(' ')[2]}`}>
              <SafeIcon 
                icon={stat.icon} 
                className={`text-xl ${colorClasses[stat.color].split(' ')[1]}`} 
              />
            </div>
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900 mb-1">{stat.value}</p>
            <p className="text-sm font-medium text-gray-600">{stat.title}</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default AdminStatsCards;